import React from "react";

export default ({
  value,
  setValue,
  label,
  max,
  placeholder,
  required,
  error,
  notice
}) => {
  const onChange = event => {
    const { value: val } = event.target;
    if (max && val.length > max) {
      setValue(val.slice(0, max));
    } else setValue(val);
  };
  return (
    <label className={`input ${error ? "-error" : ""}`}>
      <div className="input_label">
        <div>
          {label}
          {required && <span className="input_required">*</span>}
        </div>
        {max && (
          <div className="input_count">
            {value ? value.length : 0} / {max}
          </div>
        )}
      </div>

      <textarea
        className="input_textarea"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />

      {notice && <div className="input_notice">{notice}</div>}
    </label>
  );
};
